<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-05 16:31:19
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-17 20:01:15
 * @FilePath: \partner.chaoyongtuan.com\src\views\shopManage\selectionDecoration\list\components\tableCells\titleCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="orderCell">
		<el-input v-model="row.sortOrder" @change="handleChange" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
		<div class="sort radius-4 cursor-pointer">
			<i class="i-sort"></i>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
import { setSortOrder, setOrderBanner, setOrderIcons } from '@/api/selectionDecoration';
export default {
	mixins: [mixin],
	data() {
		return {
			input: '',
		};
	},
	methods: {
		async handleChange(e) {
			const api = {
				orderGroup: setSortOrder,
				orderBanner: setOrderBanner,
				orderJG: setOrderIcons,
			};
			const params = {
				orderGroup: {
					group_id: this.row.group_id,
					product_id: this.row.product_id,
					sort_order: e,
				},
				orderBanner: {
					id: this.row.id,
					sortOrder: e,
				},
				orderJG: {
					id: this.row.id,
					sortOrder: e,
				},
			};
			await api[this.column.key](params[this.column.key]);
			this.$message.success('操作成功！');
			this.row.operations.getList();
		},
	},
};
</script>
<style lang="less" scoped>
.orderCell {
	width: 100px;

	border-radius: 4px;
	::v-deep .el-input__inner {
		border-radius: 4px;
		border: 1px solid #eaebf0;
	}
	position: relative;
	.sort {
		display: none;
		position: absolute;
		right: 6px;
		top: 3px;
	}
}
.orderCell:hover .sort {
	display: block;
}
</style>
